import { StackPanel } from '@agilepoint/wat-react-ux';
import styled from 'styled-components';
import { ReactComponent as SignInIllustration } from '../../../../assets/svg/sign-in.svg';
import { LoginControls } from './login-controls';
import { LoginHeader } from './login-header';

interface ILoginPanelProps {

}

const StyledStackPanel = styled(StackPanel)`
    border: 1px solid ${({ theme: { mobileAppAccelerator: { semanticColors } } }) => semanticColors.grayVariant5};
    box-shadow: 0px 40px 64px -32px rgba(0, 0, 0, 0.1);
    border-radius: 26px;
    margin-top: 141px;
    margin-bottom: 50px !important;
    background-color: white;
`;

const IllustrationWrapper = styled(StackPanel)`
    background-color: #E6F1FB;
    width: 443px;
    height: 100%;
    border-top-left-radius: 26px;
    border-bottom-left-radius: 26px;
    display: flex;
    align-items: center;
`;

const Wrapper = styled.div`
    height: 300px;
    width: 412px;
`;

export function LoginPanel(props: ILoginPanelProps) {
    return (
        <StyledStackPanel width="1000px" height="500px" orientation="horizontal" justifyContent="center" alignContent="center" alignment="center">
            <IllustrationWrapper orientation="vertical" justifyContent="flex-start" alignContent="center" alignment="center" height="443px">
                <LoginHeader />
                <Wrapper>
                    <SignInIllustration />
                </Wrapper>
            </IllustrationWrapper>
            <LoginControls />
        </StyledStackPanel>
    );
}
